/**
 * @param   {EditorState} editorState
 * @param   {String}      maybeActiveBlock
 * @returns {Boolean}
 */
export default function isBlockActive(editorState, maybeActiveBlock) {
  const selection = editorState.getSelection();

  const blockForKey = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());

  if (
    blockForKey.getType() === "atomic" &&
    blockForKey.getData().get("blockType") === maybeActiveBlock
  ) {
    return true;
  }

  return blockForKey.getType() === maybeActiveBlock;
}
